/*
 * @Description: 会员设置
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2023-08-08 16:58:25
 * @LastEditTime: 2023-08-09 14:38:23
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 */

import {
  get,
  post
} from '../index'
export default {
  // 会员等级下拉
  levelSelect (querys) {
    return get('member/admin/AdminMember/levelSelect', querys)
  },
  // 会员等级
  levelList (querys) {
    return get('member/admin/AdminMember/levelList', querys)
  },
  // 会员等级详情
  levelInfo (querys) {
    return get('member/admin/AdminMember/levelInfo', querys)
  },
  // 新增会员等级
  levelAdd (querys) {
    return post('member/admin/AdminMember/levelAdd', querys)
  },
  // 编辑会员等级
  levelUpdate (querys) {
    return post('member/admin/AdminMember/levelUpdate', querys)
  },
  // 删除会员等级
  levelStatusUpdate (querys) {
    return post('member/admin/AdminMember/levelStatusUpdate', querys)
  },
  // 会员权益下拉框
  rightsSelect (querys) {
    return get('member/admin/AdminMember/rightsSelect', querys)
  },
  // 会员权益
  rightsList (querys) {
    return get('member/admin/AdminMember/rightsList', querys)
  },
  // 会员权益详情
  rightsInfo (querys) {
    return get('member/admin/AdminMember/rightsInfo', querys)
  },
  // 新增会员权益
  rightsAdd (querys) {
    return post('member/admin/AdminMember/rightsAdd', querys)
  },
  // 编辑会员权益
  rightsUpdate (querys) {
    return post('member/admin/AdminMember/rightsUpdate', querys)
  },
  // 会员设置
  configInfo (querys) {
    return get('member/admin/AdminMember/configInfo', querys)
  },
  // 编辑会员设置
  configUpdate (querys) {
    return post('member/admin/AdminMember/configUpdate', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/member.js